<template>
  <div class="subscribe">
    <div class="aboutservice">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="heading-it">
              <h1>Newsletter</h1>
              <img
                src="https://res.cloudinary.com/yanfomaweb/image/upload/v1577295104/afrikeveil/line-title.png"
                alt
              />
              <p class="afIntro">
                Subscribe to our Newsletter to receive the latest news about
                Afrik Eveil!!!
              </p>
            </div>
            <div
              class="alert text-center"
              id="success-alert"
              v-if="alert"
              :class="alert == 1 ? 'alert-success' : 'alert-danger'"
            >
              <button type="button" class="close" data-dismiss="alert">x</button>
              {{ message }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="freequote contactform">
      <div class="container">
        <div class="row">
          <div class="col-md-2 col-sm-12 col-xs-12">
            <div class="title"></div>
          </div>
          <div class="col-md-10 col-sm-12 col-xs-12">
            <div class="left-it ct-form">
              <form
                method="post"
                action="https://afrikeveil.org/en/subscribe"
                class="ct-left"
                @submit.prevent="subscribe"
              >
                <input type="hidden" name="_token" value="67c3Zt09OxH6nbdNQ8EpnW3cnBGDEVJflVHYZdf1" />
                <div class="col-md-4 col-sm-12 col-xs-12">
                  <input
                    v-model="name"
                    name="name"
                    class="name"
                    type="text"
                    placeholder=" Your Name"
                    required
                  />
                </div>
                <div class="col-md-4 col-sm-12 col-xs-12">
                  <input
                    v-model="email"
                    name="email"
                    class="email"
                    type="email"
                    placeholder=" Email"
                    required
                  />
                </div>
                <div class="col-md-4 col-sm-12 col-xs-12">
                  <input name="subscribe" class="submit2" type="submit" value="Subscribe" />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import APPURL from "../constant";
export default {
  mounted() {},
  data() {
    return {
      name: "",
      email: "",
      response: {},
      alert: null,
      message: ""
    };
  },
  methods: {
    subscribe: function() {
      //console.log(this.action);
      // const configAxios = {
      //   headers: {
      //     "Content-Type": "application/json"
      //   }
      //};
      axios({
        method: "post",
        url: APPURL.LINK + "subscribe/",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          crossorigin: true
        },
        data: { name: this.name, email: this.email }
      })
        .then(response => {
          //return response;
          this.message = `${this.$i18n.t("subscribeSuccess")}`;
          this.alert = 1;
          return response;
          //console.log(response);
          //document.getElementById("message").innerHTML = response.data;
        })
        .catch(error => {
          //return error;
          this.message = `${this.$i18n.t("subscribeError")}`;
          this.alert = 2;
          return error;
          //console.log(error.message);
          // console.log(error);
          //document.getElementById("message").innerHTML = error;
        });
    }
  },
  name: "Subscribe",
  action: {
    required: true,
    type: String
  }
};
</script>

<style scoped lang="scss">
.freequote {
  padding: 60px 0;
  background: url("https://res.cloudinary.com/yanfomaweb/image/upload/v1577005474/afrikeveil/newsletter.png")
    no-repeat;
  background-position: center;
  background-size: cover;
}
.contactform .left-it form.ct-left {
  padding: 0;
  background: none;
}

.freequote .title h1 {
  font-family: "Josefin Sans", sans-serif;
  font-size: 40px;
  color: #f9f9f9;
  font-weight: 700;
  text-transform: capitalize;
}

.freequote .submit2 {
  background-color: #2d6e0f !important;
  border: 1px solid transparent;
  width: auto;
  height: 53px;
  color: #f9f9f9;
  font-size: 16px;
  padding: 10px;
  text-align: center;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  cursor: pointer;
}

.freequote .submit2:hover {
  background: #f9f9f9 !important;
  color: #2d6e0f !important;
  border: 1px solid #5bbc2e;
  -webkit-transition: all 0.5s ease-out;
  -moz-transition: all 0.5s ease-out;
  -o-transition: all 0.5s ease-out;
  transition: all 0.5s ease-out;
  cursor: pointer;
}
.freequote form.ct-left input {
  height: 50px;
  padding-left: 10px;
  margin-right: 30px !important;
  background: #f9f9f9;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  border: none !important;
}
@media screen and (max-width: 768px) {
  .freequote form.ct-left input {
    width: 600px !important;
    margin-bottom: 30px !important;
    margin-left: 35px !important;
  }
}
@media screen and (max-width: 480px) {
  .freequote form.ct-left input {
    width: 300px !important;
    margin-bottom: 30px !important;
    margin-left: 25px !important;
  }
}
@media (max-width: 320px) {
  .freequote form.ct-left input {
    width: 200px !important;
    margin-bottom: 30px !important;
    margin-left: 30px !important;
  }
}
</style>
